/* PDP_MOBILE_DOCK_04_2026_10_18
 * Button-only presentation: no duplicate title, price or selection parsing.
 * Retains native-select focus handling and measured Inbox launcher clearance.
 * Presentation only. The original button stays inside its original form;
 * Impulse AjaxProduct remains the only purchase owner.
 */
(function () {
  'use strict';
  if (window.MekhannPdpMobileDock) return;
  var ROOT = '[data-mekhann-mobile-purchase="true"]';
  var instances = [];

  function text(node) { return node ? node.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function element(className, parent) {
    var node = document.createElement('div');
    node.className = className;
    if (parent) parent.appendChild(node);
    return node;
  }
  function typing() {
    var active = document.activeElement;
    // A native select can keep focus after its picker closes. That alone is
    // not text entry; actual viewport keyboard/pinch suppression remains below.
    return Boolean(active && active.matches('textarea, [contenteditable="true"], input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="radio"]):not([type="checkbox"]):not([type="range"])'));
  }

  function Dock(root, button) {
    this.root = root;
    this.button = button;
    this.form = button.form;
    this.frame = 0;
    this.docked = false;
    // Initial phone panel: 52px button + 10/12px padding + 1px border.
    // Once placed, the measured height includes the actual safe-area inset.
    this.dockHeight = 75;
    this.suppressed = false;
    this.chatClearanceHeight = 0;
    this.destroyed = false;
    this.measureDirty = true;
    this.submittedFromDock = false;
    this.listeners = [];
    this.anchor = element('mekhann-pdp-dock');
    this.panel = element('mekhann-pdp-dock__panel', this.anchor);
    button.parentNode.insertBefore(this.anchor, button);
    this.panel.appendChild(button);
    this.anchor.setAttribute('data-mekhann-purchase-docked', 'false');
    root.mekhannMobileDock = this;

    var self = this;
    this.schedule = function () {
      if (!self.frame && !self.destroyed) self.frame = window.requestAnimationFrame(function () {
        self.frame = 0;
        self.update();
      });
    };
    this.resized = function () { self.measureDirty = true; self.schedule(); };
    this.listen(window, 'scroll', this.schedule, { passive: true });
    this.listen(window, 'resize', this.resized, { passive: true });
    this.listen(window, 'load', this.resized, { once: true });
    this.listen(document, 'focusin', this.schedule);
    this.listen(document, 'focusout', this.schedule);
    // Native options, quantity and stock labels can change the surrounding
    // layout. Re-evaluate geometry without mirroring or parsing product data.
    this.listen(root, 'change', this.schedule);
    this.listen(root, 'variantChange', this.schedule);
    this.listen(root, 'input', this.schedule);
    this.listen(root, 'mekhann:product-quantity', this.schedule);
    this.listen(this.form, 'submit', function () { self.submittedFromDock = self.docked; }, true);
    this.listen(document, 'ajaxProduct:added', function (event) {
      if (event.detail && event.detail.addToCartBtn === self.button) self.submittedFromDock = false;
    });
    this.listen(document, 'ajaxProduct:error', function () { self.revealError(); });
    if (window.visualViewport) {
      this.listen(window.visualViewport, 'resize', this.schedule, { passive: true });
      this.listen(window.visualViewport, 'scroll', this.schedule, { passive: true });
    }
    this.schedule();
  }

  Dock.prototype.listen = function (target, type, handler, options) {
    target.addEventListener(type, handler, options);
    this.listeners.push([target, type, handler, options]);
  };

  Dock.prototype.syncChatClearance = function () {
    var height = !this.destroyed && this.docked && !this.suppressed && window.innerWidth <= 600 ? Math.ceil(this.dockHeight) : 0;
    if (height === this.chatClearanceHeight) return;
    this.chatClearanceHeight = height;
    if (height) document.documentElement.style.setProperty('--mekhann-pdp-dock-height', height + 'px');
    else document.documentElement.style.removeProperty('--mekhann-pdp-dock-height');
  };

  Dock.prototype.place = function (docked) {
    if (this.docked === docked) return;
    if (docked) this.anchor.style.minHeight = Math.ceil(this.anchor.getBoundingClientRect().height) + 'px';
    else this.anchor.style.removeProperty('min-height');
    this.docked = docked;
    this.anchor.setAttribute('data-mekhann-purchase-docked', String(docked));
    if (docked) this.dockHeight = this.panel.getBoundingClientRect().height || this.dockHeight;
    this.syncChatClearance();
  };

  Dock.prototype.update = function () {
    if (this.destroyed) return;
    if (!this.root.isConnected || !this.button.isConnected) { this.destroy(); return; }
    if (this.measureDirty) { this.place(false); this.measureDirty = false; }
    var viewport = window.visualViewport;
    var height = window.innerHeight || document.documentElement.clientHeight;
    var suppressed = typing() || Boolean(viewport && (viewport.scale > 1.05 || height - viewport.height > 120));
    this.suppressed = suppressed;
    this.anchor.toggleAttribute('data-mekhann-purchase-suppressed', suppressed);
    if (window.innerWidth > 600) { this.place(false); return; }
    if (this.revealedError && this.form.contains(this.revealedError)) { this.place(false); return; }
    var bounds = this.root.getBoundingClientRect();
    var anchor = this.anchor.getBoundingClientRect();
    var header = document.querySelector('.site-header--stuck, .header-wrapper--sticky');
    var headerBounds = header && header.getBoundingClientRect();
    var top = headerBounds && headerBounds.top <= 0 && headerBounds.bottom > 0 ? Math.min(headerBounds.bottom, height / 2) : 0;
    var visible = anchor.top >= top + 8 && anchor.bottom <= height - 12;
    // Retain the last real dock height in both states. A different fallback
    // while undocked would alternate eligibility at the end of short PDPs.
    if (this.docked) this.dockHeight = this.panel.getBoundingClientRect().height || this.dockHeight;
    var inProduct = bounds.top < height - 52 && bounds.bottom > height - this.dockHeight;
    this.place(!visible && inProduct && anchor.width > 0);
    if (this.docked && bounds.bottom <= height - this.dockHeight) this.place(false);
    this.syncChatClearance();
  };

  Dock.prototype.revealError = function () {
    if (!this.submittedFromDock || this.destroyed) return;
    var error = this.form.querySelector('.errors[role="alert"]');
    if (!error || !text(error)) return;
    this.submittedFromDock = false;
    this.revealedError = error;
    this.place(false);
    // Reveal the native message and its existing recovery controls. Do not
    // duplicate it in the dock, hide validation or submit the form again.
    if (!error.hasAttribute('tabindex')) error.setAttribute('tabindex', '-1');
    error.focus({ preventScroll: true });
    error.scrollIntoView({ block: 'center', behavior: 'auto' });
    this.schedule();
  };

  Dock.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;
    this.syncChatClearance();
    window.cancelAnimationFrame(this.frame);
    this.listeners.forEach(function (entry) { entry[0].removeEventListener(entry[1], entry[2], entry[3]); });
    this.listeners = [];
    if (this.anchor.parentNode && this.button.parentNode === this.panel) {
      this.anchor.parentNode.insertBefore(this.button, this.anchor);
      this.anchor.remove();
    }
    delete this.root.mekhannMobileDock;
    instances = instances.filter(function (entry) { return entry !== this; }, this);
  };

  function init(scope) {
    var roots = [];
    if (scope.matches && scope.matches(ROOT)) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(ROOT)));
    roots.forEach(function (root) {
      if (root.mekhannMobileDock || root.dataset.modal === 'true') return;
      var button = root.querySelector('.product-single__form button[type="submit"][data-add-to-cart]');
      // No-buy pages have no native purchase button; never create one.
      if (button && button.form) instances.push(new Dock(root, button));
    });
  }

  window.MekhannPdpMobileDock = { version: 'PDP_MOBILE_DOCK_04_2026_10_18' };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.slice().forEach(function (entry) { if (event.target === entry.root || event.target.contains(entry.root)) entry.destroy(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
